/* Súper zoom (23 oct 2026, fallo de Moon: «poder hacer súper zoom y ver detalles de la carta»).
   Motor del diálogo de snippets/zoom.liquid. Quien lo usa llama:
     window.MoonsZoom.abre(lista, indice, alCambiar)
   lista = [{ src, grande, ancho, alto, etiqueta, alt }]: src es la imagen que ya cargó la página (abre al instante),
   grande la de máxima resolución (se pide al acercar), ancho/alto el tamaño real del escaneo.
   Acercar: rueda, pellizco, doble clic o doble toque en un punto, botones − / + y teclas + − 0. Mover: arrastrar,
   flechas con la imagen acercada o el minimapa. Con la imagen ajustada, flechas y deslizar cambian de vista.
   El tope es 3 píxeles de pantalla por píxel del escaneo (nunca menos de ×2): un escaneo de WOP (≈ 1,520 px de
   ancho) llega a unas ×8 en escritorio y ×10 en celular. Sin animaciones en bucle; con «reducir movimiento» los
   saltos de los botones son instantáneos (--t-base = 0). */
(function () {
  if (window.MoonsZoom) return;
  var dlg = document.querySelector('[data-lightbox]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var lienzo = dlg.querySelector('[data-zoom-lienzo]');
  var img = dlg.querySelector('[data-zoom-img]');
  var vistas = dlg.querySelector('[data-zoom-vistas]');
  var nivel = dlg.querySelector('[data-zoom-nivel]');
  var mapa = dlg.querySelector('[data-zoom-mapa]');
  var mapaImg = dlg.querySelector('[data-zoom-mapa-img]');
  var marco = dlg.querySelector('[data-zoom-marco]');
  var ayuda = dlg.querySelector('[data-zoom-ayuda]');
  var cargando = dlg.querySelector('[data-zoom-cargando]');
  var bMas = dlg.querySelector('[data-zoom-mas]');
  var bMenos = dlg.querySelector('[data-zoom-menos]');
  var bAjustar = dlg.querySelector('[data-zoom-ajustar]');
  if (!lienzo || !img) return;

  var PX_MAX = 3;        // píxeles de pantalla por píxel del escaneo, como máximo
  var FACTOR_MIN = 2;    // el tope nunca queda por debajo de ×2 sobre «ajustado»
  var PASO = 1.6;        // cada clic en + o −
  var MARGEN = 16;       // aire alrededor de la imagen ajustada

  var lista = [];
  var actual = 0;
  var alCambiar = null;
  var ultimoFoco = null;
  var W = 1, H = 1;      // tamaño real del escaneo (px)
  var s = 1, ajuste = 1, tope = 3, x = 0, y = 0;
  var vw = 0, vh = 0;
  var hdPedida = false;
  var tactil = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (tactil && ayuda && ayuda.dataset.tactil) ayuda.textContent = ayuda.dataset.tactil;

  function limita(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function acercado() { return s > ajuste * 1.01; }

  function mide() {
    vw = lienzo.clientWidth || window.innerWidth || 1;
    vh = lienzo.clientHeight || window.innerHeight || 1;
    var margen = vw < 600 ? 8 : MARGEN;
    ajuste = Math.max(0.01, Math.min((vw - margen * 2) / W, (vh - margen * 2) / H));
    tope = Math.max(PX_MAX, ajuste * FACTOR_MIN);
  }

  function encuadra() {
    var sw = W * s, sh = H * s;
    x = sw <= vw ? (vw - sw) / 2 : limita(x, vw - sw, 0);
    y = sh <= vh ? (vh - sh) / 2 : limita(y, vh - sh, 0);
  }

  function texto(r) {
    var n = r < 9.95 ? Math.round(r * 10) / 10 : Math.round(r);
    return '×' + String(n);
  }

  function pinta(animado) {
    encuadra();
    if (animado) {
      img.classList.add('is-animando');
      clearTimeout(pinta.t);
      pinta.t = setTimeout(function () { img.classList.remove('is-animando'); }, 320);
    } else {
      img.classList.remove('is-animando');
    }
    img.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + s + ')';
    var cerca = acercado();
    dlg.classList.toggle('is-acercado', cerca);
    if (nivel) nivel.textContent = texto(s / ajuste);
    if (bMenos) bMenos.setAttribute('aria-disabled', cerca ? 'false' : 'true');
    if (bAjustar) bAjustar.setAttribute('aria-disabled', cerca ? 'false' : 'true');
    if (bMas) bMas.setAttribute('aria-disabled', s >= tope * 0.999 ? 'true' : 'false');
    pintaMapa(cerca);
    if (cerca) pideHD();
  }

  function pintaMapa(cerca) {
    if (!mapa || !marco) return;
    mapa.hidden = !cerca;
    if (!cerca) return;
    var mw = mapa.clientWidth, mh = mw * H / W;
    var sw = W * s, sh = H * s;
    var l = limita(-x / sw, 0, 1) * mw;
    var t = limita(-y / sh, 0, 1) * mh;
    var w = Math.min(1, vw / sw) * mw;
    var h = Math.min(1, vh / sh) * mh;
    marco.style.left = l + 'px';
    marco.style.top = t + 'px';
    marco.style.width = Math.max(4, w) + 'px';
    marco.style.height = Math.max(4, h) + 'px';
  }

  function zoomEn(nuevo, cx, cy, animado) {
    nuevo = limita(nuevo, ajuste, tope);
    x = cx - (cx - x) * nuevo / s;
    y = cy - (cy - y) * nuevo / s;
    s = nuevo;
    pinta(animado);
    callaAyuda();
  }

  function ajusta(animado) {
    s = ajuste;
    pinta(animado);
  }

  function callaAyuda() {
    if (ayuda && !ayuda.hidden && acercado()) ayuda.hidden = true;
  }

  function pideHD() {
    var item = lista[actual];
    if (hdPedida || !item || !item.grande || item.grande === item.src) return;
    hdPedida = true;
    var indice = actual;
    var aviso = setTimeout(function () { if (cargando) cargando.hidden = false; }, 300);
    var hd = new Image();
    hd.decoding = 'async';
    hd.onload = function () {
      clearTimeout(aviso);
      if (cargando) cargando.hidden = true;
      if (indice === actual && dlg.open) img.src = item.grande;
    };
    hd.onerror = function () {
      clearTimeout(aviso);
      if (cargando) cargando.hidden = true;
    };
    hd.src = item.grande;
  }

  function punto(e) {
    var r = lienzo.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }

  function pintaVistas() {
    if (!vistas) return;
    vistas.innerHTML = '';
    if (lista.length < 2) { vistas.hidden = true; return; }
    lista.forEach(function (item, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zoom__vista';
      b.textContent = item.etiqueta || String(k + 1);
      b.setAttribute('aria-pressed', k === actual ? 'true' : 'false');
      b.addEventListener('click', function () { cambia(k); });
      vistas.appendChild(b);
    });
    vistas.hidden = false;
  }

  function carga(k) {
    actual = k;
    var item = lista[k];
    W = item.ancho || 1200;
    H = item.alto || 1500;
    hdPedida = false;
    if (cargando) cargando.hidden = true;
    img.removeAttribute('srcset');
    img.onload = null;
    if (!item.ancho) {
      /* Sin tamaño real en los datos: se toma la proporción de la imagen cuando llega */
      img.onload = function () {
        img.onload = null;
        if (actual !== k || !img.naturalWidth) return;
        item.ancho = img.naturalWidth;
        item.alto = img.naturalHeight;
        W = item.ancho;
        H = item.alto;
        img.style.width = W + 'px';
        img.style.height = H + 'px';
        mide();
        ajusta(false);
      };
    }
    img.src = item.src;
    img.alt = item.alt || '';
    img.style.width = W + 'px';
    img.style.height = H + 'px';
    if (mapaImg) mapaImg.src = item.src;
    if (vistas) {
      Array.prototype.forEach.call(vistas.children, function (b, i) {
        b.setAttribute('aria-pressed', i === k ? 'true' : 'false');
      });
    }
    mide();
    ajusta(false);
  }

  function cambia(k) {
    if (lista.length < 2) return;
    k = (k + lista.length) % lista.length;
    carga(k);
    if (typeof alCambiar === 'function') alCambiar(k);
  }

  /* Rueda: acerca o aleja en el punto del cursor (el pellizco del trackpad llega como rueda con ctrl).
     El punto de la imagen bajo el cursor se fija al primer giro y se conserva durante toda la tanda: así, aunque la
     imagen vaya centrada mientras es más chica que la pantalla, al final queda bajo el cursor lo que se señaló. */
  var ancla = null;
  lienzo.addEventListener('wheel', function (e) {
    e.preventDefault();
    var dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? vh : 1);
    var dx = e.deltaX * (e.deltaMode === 1 ? 16 : 1);
    if (!e.ctrlKey && Math.abs(dx) > Math.abs(dy) && acercado()) {
      x -= dx;
      ancla = null;
      pinta(false);
      return;
    }
    var p = punto(e);
    var ahora = Date.now();
    if (!ancla || ahora - ancla.t > 300 || Math.abs(p.x - ancla.cx) + Math.abs(p.y - ancla.cy) > 12) {
      ancla = { ix: (p.x - x) / s, iy: (p.y - y) / s, cx: p.x, cy: p.y };
    }
    ancla.t = ahora;
    s = limita(s * Math.exp(-dy * (e.ctrlKey ? 0.01 : 0.0015)), ajuste, tope);
    x = ancla.cx - ancla.ix * s;
    y = ancla.cy - ancla.iy * s;
    pinta(false);
    callaAyuda();
  }, { passive: false });

  /* Doble clic: si está ajustada, acerca a tamaño real en ese punto; si ya está acercada, vuelve a ajustar */
  function alternaEn(p) {
    if (acercado()) ajusta(true);
    else zoomEn(Math.max(ajuste * 3, 1), p.x, p.y, true);
  }
  var ultimoTipo = 'mouse';
  lienzo.addEventListener('dblclick', function (e) {
    if (ultimoTipo !== 'mouse') return;
    alternaEn(punto(e));
  });

  /* Punteros: un dedo o el mouse arrastran; dos dedos pellizcan; toque doble alterna; deslizar cambia de vista */
  var punteros = {};
  var gesto = null;
  var ultimoToque = null;

  function cuantos() { return Object.keys(punteros).length; }
  function lista2() { var k = Object.keys(punteros); return [punteros[k[0]], punteros[k[1]]]; }

  function empieza() {
    var n = cuantos();
    if (n === 1) {
      var p = punteros[Object.keys(punteros)[0]];
      gesto = { tipo: 'arrastre', x0: p.x, y0: p.y, tx: x, ty: y, t0: Date.now(), movido: false, mouse: p.mouse };
    } else if (n === 2) {
      var a = lista2();
      var mx = (a[0].x + a[1].x) / 2, my = (a[0].y + a[1].y) / 2;
      gesto = { tipo: 'pellizco', d0: Math.max(10, Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y)), s0: s, ix: (mx - x) / s, iy: (my - y) / s, movido: true };
    }
  }

  lienzo.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest('[data-zoom-mapa]')) return;
    ultimoTipo = e.pointerType || 'mouse';
    var p = punto(e);
    punteros[e.pointerId] = { x: p.x, y: p.y, mouse: e.pointerType === 'mouse' };
    try { lienzo.setPointerCapture(e.pointerId); } catch (err) {}
    empieza();
    if (acercado() && cuantos() === 1) dlg.classList.add('is-arrastrando');
  });

  lienzo.addEventListener('pointermove', function (e) {
    if (!punteros[e.pointerId] || !gesto) return;
    var p = punto(e);
    punteros[e.pointerId].x = p.x;
    punteros[e.pointerId].y = p.y;
    if (gesto.tipo === 'arrastre') {
      var dx = p.x - gesto.x0, dy = p.y - gesto.y0;
      if (Math.abs(dx) + Math.abs(dy) > 6) gesto.movido = true;
      if (acercado()) {
        x = gesto.tx + dx;
        y = gesto.ty + dy;
        pinta(false);
      }
    } else if (gesto.tipo === 'pellizco' && cuantos() >= 2) {
      var a = lista2();
      var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
      var mx = (a[0].x + a[1].x) / 2, my = (a[0].y + a[1].y) / 2;
      s = limita(gesto.s0 * d / gesto.d0, ajuste, tope);
      x = mx - gesto.ix * s;
      y = my - gesto.iy * s;
      pinta(false);
      callaAyuda();
    }
  });

  function suelta(e) {
    if (!punteros[e.pointerId]) return;
    var p = punto(e);
    var g = gesto;
    delete punteros[e.pointerId];
    dlg.classList.remove('is-arrastrando');
    if (cuantos() > 0) { empieza(); return; }
    gesto = null;
    if (!g || g.tipo !== 'arrastre' || e.type === 'pointercancel') return;
    var dx = p.x - g.x0, dy = p.y - g.y0;
    if (!g.mouse && !acercado() && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - g.t0 < 700) {
      cambia(actual + (dx < 0 ? 1 : -1));
      return;
    }
    if (!g.mouse && !g.movido) {
      var ahora = Date.now();
      if (ultimoToque && ahora - ultimoToque.t < 320 && Math.hypot(p.x - ultimoToque.x, p.y - ultimoToque.y) < 40) {
        ultimoToque = null;
        alternaEn(p);
      } else {
        ultimoToque = { t: ahora, x: p.x, y: p.y };
      }
    }
  }
  lienzo.addEventListener('pointerup', suelta);
  lienzo.addEventListener('pointercancel', suelta);

  /* Minimapa: clic o arrastre centran la vista en ese punto */
  if (mapa) {
    var moviendoMapa = false;
    var centraDesdeMapa = function (e) {
      var r = mapa.getBoundingClientRect();
      var fx = limita((e.clientX - r.left) / r.width, 0, 1);
      var fy = limita((e.clientY - r.top) / r.height, 0, 1);
      x = vw / 2 - fx * W * s;
      y = vh / 2 - fy * H * s;
      pinta(false);
    };
    mapa.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
      moviendoMapa = true;
      try { mapa.setPointerCapture(e.pointerId); } catch (err) {}
      centraDesdeMapa(e);
    });
    mapa.addEventListener('pointermove', function (e) { if (moviendoMapa) centraDesdeMapa(e); });
    mapa.addEventListener('pointerup', function () { moviendoMapa = false; });
    mapa.addEventListener('pointercancel', function () { moviendoMapa = false; });
  }

  /* Botones y teclado */
  function centro() { return { x: vw / 2, y: vh / 2 }; }
  if (bMas) bMas.addEventListener('click', function () { if (bMas.getAttribute('aria-disabled') !== 'true') { var c = centro(); zoomEn(s * PASO, c.x, c.y, true); } });
  if (bMenos) bMenos.addEventListener('click', function () { if (bMenos.getAttribute('aria-disabled') !== 'true') { var c = centro(); zoomEn(s / PASO, c.x, c.y, true); } });
  if (bAjustar) bAjustar.addEventListener('click', function () { if (bAjustar.getAttribute('aria-disabled') !== 'true') ajusta(true); });

  dlg.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    var c = centro();
    var paso = Math.max(40, Math.min(vw, vh) * 0.15);
    switch (e.key) {
      case '+':
      case '=':
        e.preventDefault(); zoomEn(s * PASO, c.x, c.y, true); break;
      case '-':
      case '_':
        e.preventDefault(); zoomEn(s / PASO, c.x, c.y, true); break;
      case '0':
        e.preventDefault(); ajusta(true); break;
      case 'ArrowLeft':
        e.preventDefault();
        if (acercado()) { x += paso; pinta(true); } else cambia(actual - 1);
        break;
      case 'ArrowRight':
        e.preventDefault();
        if (acercado()) { x -= paso; pinta(true); } else cambia(actual + 1);
        break;
      case 'ArrowUp':
        if (acercado()) { e.preventDefault(); y += paso; pinta(true); }
        break;
      case 'ArrowDown':
        if (acercado()) { e.preventDefault(); y -= paso; pinta(true); }
        break;
    }
  });

  /* La × cierra; también un clic en el fondo oscurecido (el diálogo no tiene relleno, así que el único punto donde el
     destino del clic es el propio <dialog> es fuera de la ventana) */
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-zoom-cerrar]')) dlg.close();
  });

  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('is-zoom-abierto');
    punteros = {};
    gesto = null;
    dlg.classList.remove('is-arrastrando');
    if (ultimoFoco && typeof ultimoFoco.focus === 'function') ultimoFoco.focus({ preventScroll: true });
  });

  /* Si cambia el tamaño de la ventana (o se gira el celular), se conserva el acercamiento y el punto central */
  window.addEventListener('resize', function () {
    if (!dlg.open) return;
    var r = s / ajuste;
    var ix = (vw / 2 - x) / s, iy = (vh / 2 - y) / s;
    mide();
    s = limita(ajuste * r, ajuste, tope);
    x = vw / 2 - ix * s;
    y = vh / 2 - iy * s;
    pinta(false);
  });

  window.MoonsZoom = {
    abre: function (items, indice, cambio) {
      if (!items || !items.length) return;
      lista = items;
      alCambiar = cambio || null;
      ultimoFoco = document.activeElement;
      actual = limita(indice || 0, 0, lista.length - 1);
      pintaVistas();
      if (ayuda) ayuda.hidden = false;
      document.documentElement.classList.add('is-zoom-abierto');
      dlg.showModal();
      carga(actual);
      lienzo.focus({ preventScroll: true });
    },
    cierra: function () { if (dlg.open) dlg.close(); }
  };
})();
